export default function ErrorPage403() {
  return (
    <div id="error-page">
      <h1>403 Forbidden</h1>
      <p>You are not authorized to access this resource.</p>
    </div>
  );
}
